
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { MenuApiService } from '../menu-api.service';
import { MenuStoreService } from '../menu-store.service';
import {ConsumersActions} from '@emm/menu/store/consumer/consumers.actions';
import {ItemsActions} from '@emm/menu/store/items/items.actions';
import {FeatureScope} from '@emm/core/util/feature-scope.constants';
import * as RA from 'ramda-adjunct';

@Injectable({
    providedIn: 'root'
})
export class ItemsEffects {

    consumerSelect$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumersActions.select),
            withLatestFrom(
                this.store.queryFeatureScope.selected$,
                this.store.queryConsumers.menuParamsContext$
                ),
            filter(([_, featureScope, context]) => featureScope !== FeatureScope.Client &&
                RA.isNotNil(context?.menuKey?.location)),
            switchMap(() => of(ItemsActions.load()))
        )
    );

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ItemsActions.load),
            withLatestFrom(
                this.store.queryConsumers.menuParamsContext$,
                this.store.queryFeatureScope.selected$,
                this.store.queryLocationSets.selectedVenue$
            ),
            switchMap(([_, { effectiveDate, menuKey },featureScope, venue ]) => {
                    if ((venue && venue?.name !== 'Base Location') && menuKey?.consumer && menuKey?.location) {
                        return this.api.getMenuItemChildrenForVenue(menuKey.consumer, menuKey.location, venue.venueNumber,
                            null, effectiveDate)?.pipe(
                            map((items) => ItemsActions.loadSuccess({items})),
                            catchError(({error}) => of(ItemsActions.loadFailure({error})))
                        );
                    } else if (menuKey?.location){
                        return this.api.getMenuItemChildrenByFeatureScope(featureScope, effectiveDate, menuKey)?.pipe(
                            map((items) => ItemsActions.loadSuccess({items})),
                            catchError(({error}) => of(ItemsActions.loadFailure({error})))
                        );
                    }
                }
            )
        )
    );

    constructor(
        private actions$: Actions,
        private api: MenuApiService,
        private store: MenuStoreService
    ) {}

}
